import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const AdminRoute = ({ children }) => {
  const [authorized, setAuthorized] = useState(null); // null = loading

  useEffect(() => {
    const checkAdmin = async () => {
      // Give Supabase a moment to finish setting session
      const { data: { session } } = await supabase.auth.getSession();

      if (!session) {
        setAuthorized(false);
        return;
      }

      const { data: user, error } = await supabase
        .from('users')
        .select('role')
        .eq('id', session.user.id)
        .single();

      if (error || !user) {
        setAuthorized(false);
      } else if (user.role === 'admin') {
        setAuthorized(true);
      } else {
        setAuthorized(false);
      }
    };

    checkAdmin();
  }, []);

  if (authorized === null) {
    return <p>Checking admin access...</p>;
  }

  if (!authorized) {
    // Redirect only after we’re sure
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
